module.exports = __webpack_public_path__ + "img/h-page4-47.9cc57726.png";